import { render, staticRenderFns } from "./GoodsGetailsInfo.vue?vue&type=template&id=d8e1324c&scoped=true&"
import script from "./GoodsGetailsInfo.vue?vue&type=script&lang=js&"
export * from "./GoodsGetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGetailsInfo.vue?vue&type=style&index=0&id=d8e1324c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e1324c",
  null
  
)

export default component.exports